import type { RequestFunction } from "@kanda-libs/openapi-io-ts-runtime";
import * as t from "io-ts";
import * as schemas from "../components/schemas";

export type PayoutsJobRequestParameters = {
  job_type?: "standard" | "solar";
};

export const payoutsJobOperation = {
  path: "/api/job/all/payouts",
  method: "post",
  responses: {
    "200": { _tag: "JsonResponse", decoder: t.array(schemas.Tally) },
    default: { _tag: "JsonResponse", decoder: schemas.Error },
  },
  parameters: [
    {
      _tag: "FormParameter",
      explode: true,
      in: "query",
      name: "job_type",
    },
  ],
  requestDefaultHeaders: { Accept: "application/json" },
} as const;

export type PayoutsJobRequestFunction = RequestFunction<
  { params: PayoutsJobRequestParameters },
  Array<schemas.Tally>
>;
